// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__1xRhP","neutral":"Badge_neutral__6EHdh","success":"Badge_success__dPfX6","warning":"Badge_warning__5K4Q+","danger":"Badge_danger__ga3hX"};